var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44275 1.25719C8.44275 1.44819 8.36975 1.64019 8.22375 1.78619L4.75375 5.27319C4.61275 5.41419 4.42175 5.49319 4.22175 5.49319C4.02275 5.49319 3.83175 5.41419 3.69075 5.27319L0.218751 1.78619C-0.0732494 1.49319 -0.0732494 1.01919 0.220751 0.726189C0.514751 0.434189 0.989751 0.435189 1.28175 0.728189L4.22175 3.68119L7.16175 0.728189C7.45375 0.435189 7.92775 0.434189 8.22175 0.726189C8.36975 0.872189 8.44275 1.06519 8.44275 1.25719Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.bd7db51d837dcc377bb7baa6b14a7318.svg";
export { ForwardRef as ReactComponent };